import { Action } from "@/interface/action";

let initialState = {
  info: {},
}

export const User = (state = initialState, action: Action) => {
  switch (action.type) {
    case "SET_USER_INFO":
      return {...state, info: action.payload };
    case "USER_LOGOUT":
      return {...state, info: {} };
    case "RESET":
      return initialState;
    default:
      // 默认情况下，返回当前状态，不做任何改变
      return state;
  }
}